module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/ic-tw-0a9d1bdb11e07971bbb221cef30f9a89.png";